module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_09-7fdf5e0d1f41d7ae3919e7f201379bee.png";